<script setup>
  import Icon from "@/components/icons/Icon.vue";

  const selectedDate = defineModel('selectedDate');
  const emits = defineEmits(['dateSelected']);

  function handleDatePickerChange(e) {
    emits('dateSelected', e.target.value);
  }

</script>

<template>
  <div class="jwx-date-picker">
    <span class="jwx-date-picker__activator" >
      <Icon name="calendar-days" class="jwx-date-picker__icon" />
    </span>
    <input 
      @change="handleDatePickerChange"
      ref="date-input"
      class="jwx-date-picker__input" 
      type="date" 
      name="tide-date" 
      id="tide-date" 
      v-model="selectedDate"
    />
  </div>
</template>